import { create } from 'zustand';

type UsersState = {
  usersListlimit: number;
  setUsersListLimit: (listlimit: number) => void;
  usersListPage: number;
  setUsersListPage: (page: number) => void;
  appliedFilters: Record<string, string[]>;
  setAppliedFilters: (filters: Record<string, string[]>) => void;
  isOpenUsersModal: boolean;
  openUsersModal: () => void;
};

export const useUsersStore = create<UsersState>((set) => ({
  usersListlimit: 10,
  usersListPage: 1,
  setUsersListPage: (usersListPage) => set({ usersListPage }),
  setUsersListLimit: (usersListlimit) => set({ usersListlimit }),
  appliedFilters: {},
  setAppliedFilters: (filters) => set({ appliedFilters: filters }),
  isOpenUsersModal: false,
  openUsersModal: () =>
    set((state) => ({ isOpenUsersModal: !state.isOpenUsersModal })),
}));
